import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"

export default [
  {
    path: "/dashboard-layout-home",
    component: () => import("@/layouts/dashboard/DashboardLayout.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () => import("@/modules/home/pages/home/HomePage.vue")
      },
      {
        path: "/download-app",
        name: "download-app",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/telehealth-terms",
        name: "telehealth-terms",
        component: () => import("@/modules/home/pages/terms/TelehealthTerms.vue")
      },
      // --- Deeplinks on the mobile app ---
      {
        path: "/my-questionnaires",
        name: "my-questionnaires",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/home/schedule-appointment",
        name: "schedule-appointment",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/home/pharmacy-card",
        name: "pharmacy-card",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-household",
        name: "my-household",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/campaign",
        name: "campaign",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/appointments",
        name: "appointments",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/appointments/:appointmentId",
        name: "appointments-details",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/appointments/:appointmentId",
        name: "appointments-details",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-benefits",
        name: "my-benefits",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/care-team",
        name: "care-team",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-lab-results",
        name: "my-lab-results",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-medical-files",
        name: "my-medical-files",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-account-info",
        name: "my-account-info",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-preferred-pharmacy",
        name: "my-preferred-pharmacy",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-benefit-cards",
        name: "my-benefit-cards",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/notifications",
        name: "notifications",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/provider-profile/:providerId",
        name: "provider-profile",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-medications",
        name: "my-medications",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-journals",
        name: "my-journals",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-emergency-contacts",
        name: "my-emergency-contacts",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-health-history",
        name: "my-health-history",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/member-copilot",
        name: "member-copilot",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/member-copilot/:conversationId",
        name: "member-copilot-conversation",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/encounters/:encounterId",
        name: "encounters",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/appointment-requests/:appointmentRequestId",
        name: "appointment-requests",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/async-appointments/:asyncAppointmentId",
        name: "async-appointments",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/patient-conversations",
        name: "patient-conversations",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/patient-conversations/:patientConversationId",
        name: "patient-conversation",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      }
    ]
  }
]
